import { CodiceFiscale } from "codice-fiscale-js";

// Decodifica lato client del Codice Fiscale (nessuna chiamata esterna).
// Dal CF si ricavano con certezza: data di nascita, sesso, comune di nascita e provincia.
// Cognome e nome NON sono ricavabili con esattezza: il CF contiene solo 3 consonanti/vocali
// per ciascuno, quindi vengono restituiti come codici APPROSSIMATIVI da verificare.
export function decodeCF(cfRaw) {
  const cf = String(cfRaw || "").trim().toUpperCase();
  if (!cf) return { ok: false, error: "Inserisci prima un codice fiscale." };
  if (cf.length !== 16) return { ok: false, error: "Il codice fiscale deve avere 16 caratteri." };
  let valid = false;
  try { valid = CodiceFiscale.check(cf); } catch { valid = false; }
  if (!valid) return { ok: false, error: "Codice fiscale non valido: controlla i caratteri inseriti." };
  let inv;
  try { inv = CodiceFiscale.computeInverse(cf); } catch { return { ok: false, error: "Impossibile decodificare il codice fiscale." }; }
  const g = String(inv.day).padStart(2, "0");
  const m = String(inv.month).padStart(2, "0");
  const a = String(inv.year);
  return {
    ok: true,
    data: {
      cognomeCode: inv.surname || "",
      nomeCode: inv.name || "",
      sesso: inv.gender === "F" ? "F" : "M",
      nasc_g: g, nasc_m: m, nasc_a: a,
      data_nascita: `${a}-${m}-${g}`,
      data_nascita_display: `${g}/${m}/${a}`,
      comune_nascita: inv.birthplace || "",
      provincia_nascita: inv.birthplaceProvincia || "",
    },
  };
}
